const sectionCardDualImgCss = `
[data-type='section-card-dual-img'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-card-dual-img'] .container-page .wrap-card {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

[data-type='section-card-dual-img'] .container-page .wrap-card .card-left {
  width: 50%;
}

[data-type='section-card-dual-img'] .container-page .wrap-card .card-left h1,
[data-type='section-card-dual-img'] .container-page .wrap-card .card-left h2,
[data-type='section-card-dual-img'] .container-page .wrap-card .card-left h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 9px 0 !important;
}

[data-type='section-card-dual-img'] .container-page .wrap-card .card-left .card-title {
  margin-bottom: 20px !important;
}

[data-type='section-card-dual-img'] .container-page .wrap-card .card-left .card-btn {
  margin-top: 20px;
  text-decoration: none;
  min-height: 46px;
  background: black;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  width: max-content;
  min-width: 170px;
  border-radius: 25px;
}

[data-type='section-card-dual-img'] .container-page .wrap-card .card-right {
  width: 50%;
}

[data-type='section-card-dual-img'] .container-page .wrap-card .card-right[data-order='1'] {
  order: 1;
  padding-right: 80px;
}

[data-type='section-card-dual-img'] .container-page .wrap-card .card-right[data-order='2'] {
  order: 2;
  padding-left: 80px;
}

[data-type='section-card-dual-img'] .container-page .wrap-card .card-right .list-image {
  display: flex;
  flex-wrap: wrap;
}

[data-type='section-card-dual-img'] .container-page .wrap-card .card-right .list-image .image-item:first-child {
  width: 50%;
  transform: translate(50px, 50px);
  z-index: 2;
  scale: 0.92;
}

[data-type='section-card-dual-img'] .container-page .wrap-card .card-right .list-image .image-item:last-child {
  width: 50%;
  scale: 1;
}

[data-type='section-card-dual-img'] .container-page .wrap-card .card-right .list-image .image-item {
  aspect-ratio: 1/1;
  position: relative;
  overflow: hidden;
  border-radius: 5px;
}

[data-type='section-card-dual-img'] .container-page .wrap-card .card-right .list-image .image-item img {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  bottom: 0;
  top: 0;
  right: 0;
  object-fit: cover;
}

@container (max-width: 768px) {
  [data-type='section-card-dual-img'] [data-attribute='card-container'] {
    padding: 16px 0;
  }

  [data-type='section-card-dual-img'] .container-page .wrap-card .card-left {
    width: 100%;
    order: 2 !important;
  }

  [data-type='section-card-dual-img'] .container-page .wrap-card .card-left h1,
  [data-type='section-card-dual-img'] .container-page .wrap-card .card-left h2,
  [data-type='section-card-dual-img'] .container-page .wrap-card .card-left h3 {
    font-size: 16px;
    line-height: 24px;
  }

  [data-type='section-card-dual-img'] .container-page .wrap-card .card-right {
    width: 100%;
    order: 1 !important;
    margin-bottom: 50px;
  }

  [data-type='section-card-dual-img'] .container-page .wrap-card .card-right[data-order='1'] {
    padding-right: 0;
  }

  [data-type='section-card-dual-img'] .container-page .wrap-card .card-right[data-order='2'] {
    padding-left: 0;
  }

  [data-type='section-card-dual-img'] .container-page .wrap-card .card-right .list-image .image-item:first-child {
    transform: translate(20px, 20px);
    scale: 1;
  }
}
`;

export default sectionCardDualImgCss;
